export const CognitiveJourneyStatus = Object.freeze({
  NotEligible: { label: 'Not Eligible', order: 0, isVisible: false },
  Eligible: { label: 'Eligible', order: 1, isVisible: true },
  ClinicalInterview: { label: 'Clinical Interview', order: 1, isVisible: true },
  ConsentToScreening: { label: 'Consent to Screening', order: 2, isVisible: true },
  Screening: { label: 'Screening', order: 3, isVisible: true },
  PreAssessment: { label: 'Pre-Assessment', order: 4, isVisible: true },
  Assessment: { label: 'Assessment', order: 5, isVisible: true },
});
